import { TokenManager } from "@components/token-manager/TokenManager";
import React from "react";
import styled from "@emotion/styled";
import { LaString, LoLang, LoString } from "maven-lib/dist/consts";
import { LOCALE_LANG_KEY } from "maven-lib/dist/states";
import { classNames } from "maven-lib/dist/utils/misc";
import { HamburgerMenu } from "../components/hamburgerMenu/HamburgerMenu";
import { CrIcon } from "@maven-surface/components/base/CrIcon";
import { IconName } from "@maven-surface/components/interface/Icon";
import { useRoute } from "@maven-surface/hooks";

const StyledHeaderAppName = styled.div`
  display: flex;
  width: 100%;
  align-items: center;

  .app-name {
    width: 113px !important;
  }

  .app-hybrid-header-title-text {
    width: 100%;
  }
`;

type HeaderTitleProps =
  | { children: React.ReactNode }
  | { icon?: IconName; title: LaString }
  | { icon: IconName }
  | { appName: true }
  | { dummy: boolean };
type HeaderBarIconProps = { reserved: "HOME" | "BACK" } | { icon: IconName; path?: string; onClick?: () => void };
type HeaderLeftProps = HeaderBarIconProps;
type HeaderRightProps = HeaderBarIconProps;

export type HeaderProps = HeaderTitleProps & {
  className?: string;
  left?: HeaderLeftProps;
  right?: HeaderRightProps;
  size?: "SMALL" | "MEDIUM" | "LARGE";
};

const readableTitle = (title: LoString, lang: LoLang) => {
  switch (lang) {
    case LoLang.KO:
      return title.ko;
    case LoLang.EN:
      return title.en;
    case LoLang.FR:
      return title.fr;
    case LoLang.NL:
      return title.nl;
    default:
      return title.ko;
  }
};

const StyledAppName = styled.strong`
  @media (min-width: 451px) {
    padding-left: 7rem;
  }
`;

export function Header(props: HeaderProps) {
  const authToken = localStorage.getItem("cream:auth");
  const { pushPath } = useRoute();
  const localStorageLanguage = localStorage.getItem(LOCALE_LANG_KEY) as LoLang;

  const icon: IconName | undefined = "icon" in props ? props.icon : undefined;
  const title =
    "children" in props ? (
      <>{props.children}</>
    ) : "title" in props ? (
      <>{typeof props.title === "string" ? props.title : readableTitle(props.title, localStorageLanguage)}</>
    ) : "dummy" in props && props.dummy ? (
      <>
        <div className="app-hybrid-header-title-dummy"></div>
      </>
    ) : null;

  return (
    <>
      <div className="app-hybrid-header">
        <div className="app-hybrid-header-title">
          <StyledHeaderAppName onClick={() => pushPath("/")}>
            <StyledAppName className="app-name">{process.env.REACT_APP_NAME}</StyledAppName>
            <strong className="app-hybrid-header-title-text">{title}</strong>
          </StyledHeaderAppName>
          {authToken && (
            <div className={classNames("app-hybrid-header-title-timer")}>
              <TokenManager />
            </div>
          )}
        </div>
        {!!icon && (
          <div className="app-hybrid-header-icon">
            <CrIcon icon={icon} />
          </div>
        )}
        <HamburgerMenu />
      </div>
    </>
  );
}
